import { Button, Modal, Table } from "antd";
import Column from "antd/lib/table/Column";
import React, { useEffect, useState } from "react";
import { Header } from "../../components/Header";
import { Loading } from "../../components/Loading";
import AddDriver from "./AddDriver/AddDriver";
import CarDedication from "./CarDedication/CarDedication";
import EditDriver from "./EditDriver/EditDriver";
import FilterDrivers from "./FilterDrivers/FilterDrivers";
import useDrivers from "../../hooks/useDrivers";
import useCars from "../../hooks/useCars";
import { ContentCard } from "../../components/ContentCard/ContentCard";
import Edit from "../../assets/svg/edit-icon.svg";
import Car from "../../assets/svg/car-button-icon.svg";
import Delete from "../../assets/svg/delete-icon.svg";
import PlateNumberComponent from "../../components/PlateNumberComponent";
import CloseModalButton from "../../components/CloseModalButton/CloseModalButton";

export const Drivers = () => {
  const [isCarDedicationModalOpen, setIsCarDedicationModalOpen] =
    useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const {
    loadDrivers,
    drivers,
    pagination,
    filters,
    onChangeFilters,
    onFilterDrivers,
    isRemovePlateNumberModalOpen,
    setIsRemovePlateNumberModalOpen,
    onRemovePlate,
    changePage,
    getDriversReport,
    isAddDriverModalOpen,
    setIsAddDriverModalOpen,
    driverState,
    cities,
    setCities,
    onAddDriver,
    handleAddDriverStateChange,
  } = useDrivers({ isInDriversPage: true });
  const {
    companyEmployeeCars,
    cars,
    selectedCar,
    setSelectedCar,
    onSetCompanyEmployeeCar,
    getEmplooyeCars,
  } = useCars({
    setIsModalOpen: setIsCarDedicationModalOpen,
    onFilterDrivers,
    isCarDedicationModalOpen,
  });

  useEffect(() => {
    if (isCarDedicationModalOpen) {
      getEmplooyeCars();
    }
    // eslint-disable-next-line
  }, [isCarDedicationModalOpen]);
  return (
    <>
      <Header
        title={"Drivers Management"}
        activeItem={"drivers"}
        leftTitle={`Number of Drivers: ${drivers?.length}`}
      />

      <ContentCard
        filter={
          <FilterDrivers
            filters={filters}
            onChangeFilters={onChangeFilters}
            onFilterDrivers={onFilterDrivers}
            getDriversReport={getDriversReport}
          />
        }
        add={
          <AddDriver
            isAddDriverModalOpen={isAddDriverModalOpen}
            setIsAddDriverModalOpen={setIsAddDriverModalOpen}
            driverState={driverState}
            handleAddDriverStateChange={handleAddDriverStateChange}
            cities={cities}
            setCities={setCities}
            onAddDriver={onAddDriver}
          />
        }
      >
        <Loading isLoading={loadDrivers}>
          <Table
            dataSource={drivers}
            size="middle"
            scroll={{ x: 1250 }}
            pagination={{
              position: ["bottomCenter"],
              current: pagination.page,
              pageSize: pagination.limit,
              total: pagination.count,
              onChange: changePage,
            }}
          >
            <Column
              title={"#"}
              dataIndex="index"
              key="index"
              render={(_value, _item, index) => <>{index + 1}</>}
            />
            <Column
              title={"City"}
              dataIndex="city"
              key="city"
              render={(city, data) => (
                <>
                  <small className="color-promotion-s1 mr-10 ml-5">
                    {data.province}
                  </small>
                  <span className="mx-10">{city}</span>
                </>
              )}
            />
            <Column
              title={"Full Name"}
              dataIndex="user"
              key="user"
              render={(user) => <>{user?.fullname}</>}
            />
            <Column
              title={"National ID"}
              dataIndex="user"
              key="user"
              render={(user) => <>{user?.national_id}</>}
            />
            <Column
              title={"Mobile Number"}
              dataIndex="user"
              key="user"
              render={(user) => <>{user?.phone_number}</>}
            />
            <Column
              title={"Entry Date"}
              render={(created_at) => <>{created_at}</>}
              dataIndex="created_at"
              key="created_at"
            />
            <Column
              title={"Car Plate"}
              dataIndex="plate_number"
              key="plate_number"
              render={(plate_number) => plate_number}
            />
            <Column
              title="Actions"
              render={(_v, data, index) => (
                <div className="flex-row flex-wrap">
                  <Button
                    className="button-white ml-10"
                    onClick={() => setIsCarDedicationModalOpen(index)}
                  >
                    <img src={Car} alt="" width="35px" />
                  </Button>
                  <CarDedication
                    isModalOpen={isCarDedicationModalOpen === index}
                    setIsModalOpen={setIsCarDedicationModalOpen}
                    isRemovePlateNumberModalOpen={isRemovePlateNumberModalOpen}
                    setIsRemovePlateNumberModalOpen={
                      setIsRemovePlateNumberModalOpen
                    }
                    companyEmployeeCars={
                      data?.plate_number && cars
                        ? cars?.data.filter(
                            (car) =>
                              car.plate_number.number_plate_part_1 ===
                                data?.plate_number?.number_plate_part_1 &&
                              car.plate_number.number_plate_part_2 ===
                                data.plate_number.number_plate_part_2 &&
                              car.plate_number.number_city_code ===
                                data.plate_number.number_city_code &&
                              car.plate_number.number_plate_alphabet ===
                                data.plate_number.number_plate_alphabet
                          )
                        : companyEmployeeCars?.data || []
                    }
                    cars={cars?.data || []}
                    selectedCar={selectedCar}
                    setSelectedCar={setSelectedCar}
                    onSetCompanyEmployeeCar={onSetCompanyEmployeeCar}
                    onRemovePlate={onRemovePlate}
                    data={data}
                    index={index}
                  />
                  <Button
                    className="button-white ml-10"
                    onClick={() => setIsEditModalOpen(index)}
                    key={index}
                  >
                    <img src={Edit} alt="" width="20px" />
                  </Button>
                  <EditDriver
                    isModalOpen={isEditModalOpen === index}
                    setIsModalOpen={setIsEditModalOpen}
                    data={data}
                    onFilterDrivers={onFilterDrivers}
                  />
                  <Button
                    className="button-white ml-10"
                    onClick={() => setIsRemovePlateNumberModalOpen(index)}
                    key={index}
                  >
                    <img src={Delete} alt="" width="20px" />
                  </Button>
                  <Modal
                    open={isRemovePlateNumberModalOpen === index}
                    onCancel={() => setIsRemovePlateNumberModalOpen(false)}
                    footer={null}
                    closable={true}
                    title="Remove Driver"
                    bodyStyle={{
                      paddingBottom: 8,
                    }}
                    closeIcon={
                      <CloseModalButton
                        isCloseIcon
                        close={() => setIsRemovePlateNumberModalOpen(false)}
                      />
                    }
                  >
                    <p className="text-center">
                      Are you sure you want to remove the selected driver?
                    </p>
                    <div className="flex-row flex-content-space-between">
                      <Button
                        className="button-secondary w-45 ml-10"
                        onClick={() => onRemovePlate(data, null, true)}
                        key={index}
                      >
                        Yes
                      </Button>
                      <Button
                        className="button-red w-45 ml-10"
                        onClick={() => setIsRemovePlateNumberModalOpen(false)}
                        key={index}
                      >
                        No
                      </Button>
                    </div>
                  </Modal>
                </div>
              )}
            />
          </Table>
        </Loading>
      </ContentCard>
    </>
  );
};
